const externalUrls = {
    facebook_metrics_labeling: 'https://www.facebook.com/business/help/metrics-labeling',
    tiktok_music_usage_confirmation: 'https://www.tiktok.com/legal/music-usage-confirmation'
} as const;

export default externalUrls;
